import { useEffect, useRef } from "react";

export default function AudioPlayer(props: {
    audioUrl: string;
    mimeType: string;
}) {
    const audioPlayer = useRef<HTMLAudioElement>(null);
    const audioSource = useRef<HTMLSourceElement>(null);

    // Updates src when url changes
    useEffect(() => {
        if (audioPlayer.current && audioSource.current) {
            audioSource.current.src = props.audioUrl;
            audioPlayer.current.load();
        }
    }, [props.audioUrl]);

    return (
        <div className='flex relative z-10 p-2 w-full max-w-full'> {/* Reduced padding */}
            <audio
                ref={audioPlayer}
                controls
                className='w-full h-12 rounded-lg bg-white dark:bg-gray-800 shadow-none ring-0' // Reduced height, removed shadow and ring
            >
                <source ref={audioSource} type={props.mimeType}></source>
            </audio>
        </div>
    );
}